import styled from "@emotion/styled";
import {Flex} from "../../ui";

export const Container = styled(Flex)`
    position:relative;
    width:100%;
    height:auto;   
    min-height:100%;
    align-content:flex-start;
    flex-flow:column nowrap;
    background-image:url(${props=> props.plantilla});
      background-position : center bottom;
      background-size     : cover ;
      background-repeat   : no-repeat;

`;

export  const ConFacturas = styled(Flex)`
    width:100%;
    flex:1 0 auto;
    overflow: inherit;
`;


export  const ConFacturaCard = styled(Flex)`
    width:100%;
    flex:0 0 auto;
  
   @media all and (min-width:998px){
     max-height: calc(100vh - 105px);
   }
`;
